import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { TrainingRequestsCompetenciesDocument } from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import TextField from 'modules/core/components/TextField'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'

type Props = {
  amplitudeEventNext: string
}
export const BasicInfoStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
}: WizardStepRenderParams<WizardData> & Props) => {
  const { data: competenciesData } = useQuery(TrainingRequestsCompetenciesDocument)
  const competencies = competenciesData?.competencies?.competencies
  const onChangeName = (trainingName: string) => {
    onDataChanged({ ...data, trainingName: trainingName })
  }

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })

  return (
    <Box width="s600" gap="s24">
      <Box gap="s16">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('trainings.training_requests.create.basic_info_step')}
        </Text>
        <Text size="300" weight="normal" color="grey1000">
          {i18n.t('trainings.training_requests.create.basic_info_description')}
        </Text>
      </Box>
      <TextField
        label={i18n.t('trainings.training_requests.create.training_name')}
        placeholder={i18n.t(
          'trainings.training_requests.create.basic_info_placeholders.training_name'
        )}
        value={data.trainingName}
        onChange={onChangeName}
        mandatory
      />
      <TextField
        label={i18n.t('trainings.training_requests.create.provider_name')}
        placeholder={i18n.t(
          'trainings.training_requests.create.basic_info_placeholders.provider_name'
        )}
        value={data.providerName}
        onChange={(providerName) => onDataChanged({ ...data, providerName })}
      />
      <TextField
        label={i18n.t('trainings.training_requests.create.external_reference')}
        placeholder={i18n.t(
          'trainings.training_requests.create.basic_info_placeholders.external_link'
        )}
        value={data.externalReference}
        onChange={(externalReference) => onDataChanged({ ...data, externalReference })}
      />
      {competencies && competencies.length > 0 && (
        <Selector.Popover
          label={i18n.t('trainings.training_requests.create.competencies_label')}
          placeholder={i18n.t('trainings.training_requests.create.select_placeholder')}
          searchPlaceholder={i18n.t('common.search')}
          blankLabel=""
          value={data.competencyIds}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          onChange={(selection) => onDataChanged({ ...data, competencyIds: selection as string[] })}
          isMultiSelect
        >
          {competencies.map((competency) => {
            return (
              <Selector.Option
                key={competency.id}
                value={competency.id}
                label={competency.name}
                searchValue={competency.name}
              >
                {competency.name}
              </Selector.Option>
            )
          })}
        </Selector.Popover>
      )}
    </Box>
  )
}
